import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers";

interface LiveStreamsUsage {
  type: string;
  value: number;
}

export const useLiveStreamsUsage = ({ enabled } = { enabled: true }) => {
  const { data: usageArray, isLoading } = useQuery<LiveStreamsUsage[]>(
    internalApi.liveStreams.usage(),
    {
      enabled,
    },
  );
  const usage: Record<string, number> = {};
  usageArray?.forEach(usageObj => {
    usage[usageObj.type] = usageObj.value;
  });

  return {
    isLoading,
    usage,
  };
};
